import { Dispatch } from 'redux';
import BaseAction from 'src/models/common/BaseAction';
import { ReduxStoreModel } from "src/redux/ReduxModel";

export interface ToggleAudioConfigAction extends BaseAction { type: 'TOGGLE_AUDIO_CONFIG'; data: boolean; }
export interface SetPreviousLocationConfigAction extends BaseAction { type: 'SET_PREVIOUS_LOCATION_CONFIG'; data: string; }
export interface ResetConfigAction extends BaseAction { type: "RESET_CONFIG"; }

// Declare a 'discriminated union' type. This guarantees that all references to 'type' properties contain one of the
// declared type strings (and not any other arbitrary string).
export type KnownAction = ToggleAudioConfigAction | SetPreviousLocationConfigAction | ResetConfigAction;

export default class ConfigAction {
    constructor() {
        // Dont be that guy
        throw new Error("NOOOO");
    }

    public static ToggleAudio(dispatch: Dispatch<ReduxStoreModel>) {
        return dispatch((innerDispatch: Dispatch<ReduxStoreModel>, reduxState: () => ReduxStoreModel) => {
            let state = reduxState();
            innerDispatch({ type: "TOGGLE_AUDIO_CONFIG", data: !state.Config.audioEnabled } as ToggleAudioConfigAction);
        });
    }

    public static SetPreviousLocation(dispatch: Dispatch<ReduxStoreModel>, value: string) {
        dispatch({ type: "SET_PREVIOUS_LOCATION_CONFIG", data: value } as SetPreviousLocationConfigAction);
    }
}



// WEBPACK FOOTER //
// ./src/redux/ConfigActions.ts